import { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import ThinFooter from "../Footer/ThinFooter";
import ContentWrapper from "../Atomics/ContentWrapper/ContentWrapper";
import { HeadingWrapper } from "../Atomics/SectionHeader/SectionHeader";
import { broadcastFetcher } from "../../api/requests";
import { useToaster } from "../../context/toaster";

const Broadcast = () => {
  const [formData, setFormData] = useState({
    message: "",
  });
  const { addMessage } = useToaster();

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  const showToast = (type, text) => {
    addMessage({
      id: Math.random().toString(36).substr(2, 9),
      type: type,
      text: text,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSubmit = new FormData();

    formDataToSubmit.append("message", formData.message);

    try {
      const res = await broadcastFetcher.sendMessage(formDataToSubmit);

      if (res) {
        showToast("success", "پیام با موفقیت ارسال شد.");
      }
    } catch (error) {
      console.error("broadcast error:", error);
      showToast("error", error.response.data);
    }
  };

  const handleCancelClick = () => {
    setFormData({
      message: "",
    });
  };

  return (
    <ContentWrapper>
      <Container
        fluid
        className="upload-details text-right"
        style={{
          paddingLeft: "30px",
          paddingRight: "30px",
          minHeight: "calc(100vh - 123px)",
        }}
      >
        <div
          style={{
            paddingTop: "30px",
            paddingLeft: "30px",
            paddingRight: "30px",
          }}
        >
          <Row>
            <Col>
              <div className="float-right">
                <HeadingWrapper heading="ارسال پیام به تمام مالکین و ادمین کانال ها" />
              </div>
            </Col>
          </Row>

          <Form onSubmit={handleSubmit}>
            <Form.Row>
              <Form.Group as={Col} controlId="message">
                <Form.Label>متن پیام</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder=""
                  value={formData.message}
                  onChange={handleChange}
                />
              </Form.Group>
            </Form.Row>

            <Row>
              <Col className="text-right">
                <Button
                  variant="danger"
                  type="button"
                  onClick={handleCancelClick}
                >
                  لغو
                </Button>
                <Button variant="success mr-1" type="submit">
                  ارسال
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </Container>

      <ThinFooter />
    </ContentWrapper>
  );
};

export default Broadcast;
